module.exports = {
    dynamicContent: {
        defaultScheduleKey: '',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/dynamic-content.js